<template>
 <div>
    <v-card>
      <v-toolbar light prominent flat >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
            <v-toolbar-title v-if="!getIsMobile">{{cxt.getTitle()}}</v-toolbar-title>
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
          <v-layout style="overflow:hidden" justify-end>
          </v-layout>
          <v-flex v-show="cxt.isFilterMode()" sm4 xs4>
            <v-text-field
              label="Фильтр"
              v-show="cxt.isFilterMode()"
              :value="cxt.filterString"
              v-on:input="onChangeFilter"
              solo flat
            ></v-text-field>
          </v-flex>
          <span v-show="!cxt.isSelectMode()">
          </span>
          <v-ops-btn :cxt="cxt" flat></v-ops-btn>
          </v-toolbar>
          <v-progress-linear style="margin-top: 0; margin-bottom: 0" height=2 :active="getItemSet.isProcessing()" :indeterminate="true"></v-progress-linear>
          <v-card>
          <v-card-text>
          <v-layout row>
            <v-text-field
              autofocus
              label="Введите запрос"
              hint="Название, ИНН, руководитель, учредитель, адрес"
              v-model="searchString"
              clearable
              persistent-hint
              @keyup.enter.native="search"
            ></v-text-field>
            <v-btn @click="search">Искать</v-btn>
          </v-layout>
      </v-card-text>
    <v-card-scroll ref="cardScroll" v-on:nextPage="nextPage" >
      <v-list
      three-line dense>
        <template v-for="item in this.filteredItems">
          <v-list-tile v-bind:key="getItemKey(item)" @click.stop="cxt.select(getItemKey(item))"
          :value="cxt.activated(getItemKey(item))"
          active-class="v-list__tile--highlighted"
          >
            <v-list-tile-content>
              <v-list-tile-title v-html="renderReference(item.ref)"></v-list-tile-title>
              <v-list-tile-sub-title>
                {{renderHeads(item.ref)}}
                <br/>
                ИНН: <span v-html="renderInnOrInnflHtml(item.ref.inn)"></span>
                 <span style="white-space: normal;"> {{formats.blank(item.ref.address)}}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <span>
                <v-icon v-show="item.accountId">star</v-icon>
                <v-icon v-show="!item.accountId"></v-icon>
                <v-icon v-show="item.ref.clientId">person</v-icon>
                <v-icon v-show="!item.ref.clientId"></v-icon>
                <v-icon v-show="cxt.check(getItemKey(item))">check_box</v-icon>
                <v-icon v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
                </span>
              </span>
              <div><component :is="renderCompanyFlags(item)"/></div>
              <v-tooltip bottom open-delay="500" max-width="20em">
                <v-list-tile-action-text slot="activator"><b>{{formats.blank(item.ref.createDate, formats.formatDate)}}</b></v-list-tile-action-text>
                Регистрация
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-scroll>
    </v-card>
    </v-card>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import classes from '../../api/classes'
  import apimix from '../common/apimix'
  import vOpsBtn from '../common/OpsBtn'
  import vCardScroll from '../common/CardScroll'

  class CopyInnAction extends classes.Action {
    constructor (context) {
      super(context,
        'Копировать в буфер обмена',
        null,
        () => {
          this.context.copyInnToClipboard(this.context.cxt.selectedIds)
        })
    }
  }

  export default {
    name: 'search-set',
    components: {vOpsBtn, vCardScroll},
    mixins: [apimix],
    data: () => ({
      tags: [],
      cxt: null,
      searchString: null
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.actions.push(new classes.FilterAction(cxt))
      cxt.actions.push(new classes.FilterEndAction(cxt))
      // cxt.actions.push(new classes.ActiveScopeAction(cxt))
      cxt.actions.push(new classes.AllScopeAction(cxt))
      cxt.actions.push({divider: true})
      cxt.actions.push(new classes.SelectAction(cxt))
      cxt.actions.push({divider: true})

      // cxt.selectActions.push(new classes.FilterAction(cxt))
      // cxt.selectActions.push(new classes.FilterEndAction(cxt))
      cxt.selectActions.push(new CopyInnAction(this))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectAllAction(cxt))
      cxt.selectActions.push({divider: true})
      cxt.selectActions.push(new classes.SelectEndAction(cxt))

      cxt.title = 'Компании'
      cxt.titleIcon = 'search'
      cxt.selectTitle = 'Поиск компании'
      cxt.filterMode = true

      this.cxt = cxt
    },
    mounted () {
      this.loadData()
      this.setActivated()
    },
    props: {
      itemId: {
        type: String,
        default: null
      },
      tagIds: {
        type: Array,
        default: null
      }
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        this.loadData()
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        getItemSet: 'getSearchSet',
        getProfileHaveClient: 'getProfileHaveClient',
        getRefToUrl: 'getRefToUrl',
        renderReference: 'renderReference',
        renderHeads: 'renderHeads',
        renderFlags: 'renderFlags',
        renderInnOrInnflHtml: 'renderInnOrInnflHtml'
      }),
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.filteredItems.length + '' : ''
        } else {
          return (!this.getItemSet.isLast()) ? label + this.filteredItems.length + ' первых' : label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + ''
        }
      },
      items () {
        return this.getItemSet.getItems()
      },
      orderedItems () {
        return this.items
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.ref.ref,
              item.ref.caption,
              item.ref.name,
              this.renderHeads(item.ref),
              item.ref.inn,
              item.ref.kpp,
              // this.formatDate(item.company.createDate),
              // this.formatDate(item.company.releaseDate),
              item.ref.address,
              item.notes,
              item.privateNotes)
        }
        var filter = (!this.cxt.isFilterMode()) || (this.cxt.filterString === null) || (this.cxt.filterString.length < 0) ? null : this.cxt.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        let result = this.orderedItems.filter(item => {
          return getSearchString(item).toUpperCase().includes(filter)
        })
        return result
      }
    },
    methods: {
      changeFilterContext (ops, force) {
        this.$store.commit('setSearchFilterContext', Object.assign({}, this.getItemSet.getFilter(), ops))
        var self = this
        setTimeout(() => {
          self.$store.dispatch('fetchSearchCompanies', force)
          self.scrollToActive()
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
      },
      nextPage () {
        this.$store.commit('nextSearchCompanies')
        this.$store.dispatch('fetchSearchCompanies')
      },
      loadData () {
        if (this.getProfileHaveClient) {
          this.searchString = this.getItemSet.getFilter().search
          this.fetchData()
        }
      },
      fetchData () {
        let search = this.searchString ? this.searchString : ''
        this.changeFilterContext({search: search})
      },
      getItemKey (item) {
        if (!item) {
          return null
        }
        return item.ref.ref + '_' + item.ref.inn
      },
      getInnfromKey (key) {
        return key && key.split('_').length > 0 ? key.split('_')[1] : null
      },
      renderCompanyFlags (item) {
        return this.renderFlags(item.ref.flags)
      },
      search () {
        this.fetchData()
      },
      copyInnToClipboard: function (selectedIds) {
        if (Array.isArray(selectedIds)) {
          var values = selectedIds.map(selectedId => this.getInnfromKey(selectedId))
          var text = values.join(', ')
          this.$store.dispatch('copyToClipboard', {text: text})
          this.cxt && this.cxt.toViewMode()
        }
      },
      scrollToActive () {
        this.$nextTick(() => {
          this.$refs.cardScroll.scrollToListActive()
        })
      },
      setActivated () {
        if (this.$router && this.$router.options && this.$router.options.from) {
          let from = this.$router.options.from
          if (from.params && from.params.clientInn) {
            let itemId = from.params.clientInn
            let item = this.items.find(i => '' + i.ref.ogrn === itemId)
            if (item) {
              this.cxt.activate(this.getItemKey(item))
            } else {
              this.$store.commit('setInfoStatus',
                'Позиционировать не удалось, возможно выборка была изменена. '
              )
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ClientList.vue?1f2d0230